<!-- background image -->
<div
  class="absolute h-screen w-screen bg-cover bg-center"
  style="background-image: url('assets/woordkr8/backgrounds/login-background.png')"
></div>

<!-- black background overlay -->
<div class="absolute inset-0 bg-black/50"></div>

<div class="relative flex h-screen flex-row items-center justify-center">
  <app-portal-panel class="h-[40rem] max-h-full w-3xl max-w-full">
    <div class="m-6 flex h-full flex-col gap-4">
      <!-- Top bar -->
      <div class="flex flex-row justify-between">
        <div class="barlow-semi-condensed-bold text-5xl text-white">Profielen thuis</div>
        <button
          (click)="openAddProfileDialog()"
          class="barlow-medium h-7 w-[148px] rounded-md border border-white text-center align-middle text-base text-white"
        >
          Profiel toevoegen
        </button>
      </div>
      <!-- text -->
      <div class="barlow-regular text-2xl text-white">Klik op een profiel om het te spelen.</div>
      <!-- profiles -->
      <div class="flex flex-row flex-wrap justify-between gap-6">
        @for (profile of sortedProfiles(); track $index) {
          <app-portal-button
            (click)="selectProfile(profile)"
            class="h-[105px] w-[315px] cursor-pointer transition-transform hover:scale-105"
            color="blue"
          >
            <div class="flex flex-row items-center justify-start gap-4 p-4">
              <app-portal-profile class="size-16"></app-portal-profile>
              <span class="barlow-medium text-xl"> {{ profile.name }}</span>
            </div>
          </app-portal-button>
        }
      </div>
    </div>
  </app-portal-panel>
</div>

<!-- Add profile dialog -->
@if (showAddProfileDialog()) {
  <div class="fadesIn absolute inset-0 z-50 flex items-center justify-center bg-black/80">
    <form class="relative" [formGroup]="addProfileForm" (ngSubmit)="onAddProfile()">
      <div class="h-[483px] max-h-full w-[400px] max-w-full">
        <app-portal-panel>
          <div class="flex h-full flex-col items-center justify-between">
            <div class="flex flex-col gap-4">
              <div class="barlow-semi-condensed-bold text-center text-6xl text-white">Nieuw profiel</div>
              <div class="barlow-regular text-center text-2xl text-white">Gebruik de spelerscode die je van school hebt gekregen.</div>
            </div>
            <!-- input -->
            <div class="flex w-xs flex-col items-center justify-center gap-8">
              <div class="flex w-full flex-col items-center justify-center gap-4">
                <app-portal-input
                  class="w-full"
                  id="profileName"
                  ngDefaultControl
                  formControlName="profileName"
                  placeholder="Profielnaam"
                  [showError]="showProfileNameError()"
                  errorMessage="Deze naam bestaat al."
                ></app-portal-input>

                <app-portal-input
                  class="w-full"
                  id="playerCode"
                  ngDefaultControl
                  formControlName="playerCode"
                  placeholder="Spelerscode"
                  [showError]="showPlayerCodeError()"
                  errorMessage="Deze spelerscode klopt niet of bestaat al."
                ></app-portal-input>
              </div>

              <div class="flex w-full items-center justify-between gap-4">
                <button
                  appPortalButton
                  color="red"
                  type="button"
                  (click)="closeAddProfileDialog()"
                  class="barlow-semi-condensed-semibold hover-scale-105 h-12 w-full text-lg text-black transition-transform"
                >
                  Terug
                </button>
                <button
                  [disabled]="addProfileForm.invalid"
                  appPortalButton
                  class="barlow-semi-condensed-semibold h-12 w-full text-lg"
                  [ngClass]="{ 'transition-transform hover:scale-105': addProfileForm.valid }"
                  type="submit"
                >
                  Toevoegen
                </button>
              </div>
            </div>
          </div>
        </app-portal-panel>
      </div>
    </form>
  </div>
}

<!-- Confirmation dialog for resetting app -->
@if (showResetConfirmDialog()) {
  <div class="fadesIn absolute inset-0 z-50 flex items-center justify-center bg-black/80">
    <div class="h-[444px] w-[400px]">
      <app-portal-panel>
        <div class="flex h-full flex-col justify-between gap-2 px-4">
          <div class="flex flex-col gap-2">
            <div class="barlow-semi-condensed-bold text-4xl text-white">Weet je zeker dat je de app wil resetten?</div>
            <div class="barlow-regular text-center text-2xl text-white">
              Je moet de app daarna opnieuw activeren en profielen toevoegen.
            </div>
          </div>
          <div class="flex flex-col gap-4">
            <div class="h-12 w-full">
              <app-portal-button color="blue" (click)="cancelResetApp()">
                <div class="barlow-semi-condensed-semibold text-2xl">Terug naar profielen</div>
              </app-portal-button>
            </div>
            <div class="h-12 w-full">
              <app-portal-button color="red" (click)="confirmResetApp()">
                <div class="barlow-semi-condensed-semibold my-2 text-2xl">App resetten</div>
              </app-portal-button>
            </div>
          </div>
        </div>
      </app-portal-panel>
    </div>
  </div>
}

<!-- Reset app -->
<button
  class="barlow-regular absolute top-0 right-0 flex h-28 w-44 items-center justify-center text-xl text-white"
  (click)="openResetAppDialog()"
>
  Reset App
</button>
